// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3vZN8","footer":"ModalError_footer__SDZ2E"};